import apiClient from './client';
import { API_ENDPOINTS } from './config';
import type { ProviderService, ServiceRequest } from '../types/provider';

/**
 * Services as seen by a staff member. Same entity as the provider's `/service`
 * endpoints, but scoped to the staff member's assigned location by the token —
 * there is no locationId to pass. Reads need SERVICE_VIEW and writes need
 * SERVICE_MANAGE; the backend enforces both regardless of what the UI shows.
 */
export const staffServiceApi = {
	list: async (): Promise<ProviderService[]> =>
		apiClient.get<ProviderService[]>(API_ENDPOINTS.STAFF.SERVICES),

	create: async (payload: ServiceRequest): Promise<ProviderService> =>
		apiClient.post<ProviderService>(API_ENDPOINTS.STAFF.SERVICES, payload),

	update: async (id: number, payload: ServiceRequest): Promise<ProviderService> =>
		apiClient.put<ProviderService>(API_ENDPOINTS.STAFF.SERVICE_DETAIL(id), payload),

	delete: async (id: number): Promise<void> => {
		await apiClient.delete<void>(API_ENDPOINTS.STAFF.SERVICE_DETAIL(id));
	},
};

export default staffServiceApi;
